export default "__VITE_ASSET__D6OeYe2H__"